import * as styles from './styles';
import { Box, Typography } from '@material-ui/core';

import { colors } from '../styles/colors';

interface IProps {
  title?: string;
  message?: string;
  fill?: string;
  className?: string;
}

export const Loading = ({ title, message, fill, className }: IProps) => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      flexDirection='column'
    >
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        flexDirection='column'
        gridGap={2}
      >
        {title && <Typography variant='body1'>{title}</Typography>}
        {message && (
          <Typography variant='caption' color='textSecondary'>
            {message}
          </Typography>
        )}
      </Box>
      <Box>
        <svg
          className={className}
          viewBox='0 0 52 14'
          height='14px'
          width='52px'
        >
          <g
            stroke='none'
            strokeWidth='1'
            fill={fill || colors.primary.default}
            fillRule='evenodd'
          >
            <circle
              className={`${styles.circle} ${styles.circleLoading}`}
              cx='7'
              cy='7'
              r='7'
            />
            <circle
              className={`${styles.circle} ${styles.circleLoading}`}
              cx='26'
              cy='7'
              r='7'
            />
            <circle
              className={`${styles.circle} ${styles.circleLoading}`}
              cx='45'
              cy='7'
              r='7'
            />
          </g>
        </svg>
      </Box>
    </Box>
  );
};
